export default () => ({

  host: undefined,

  snackbar: false,
  snackbarText: false,
  snackbarColor: 'error',
  isSnackbarVertical: false,

  timeout: 10000,
  centered: true,

  differenceToServerTime: 0,
  hideNavbar: {
    '/wohnmobil-bewerten': true,
    '/wohnmobil-bewerten/schritt-1-von-3': true,
    '/wohnmobil-bewerten/schritt-2-von-3': true,
    '/wohnmobil-bewerten/schritt-3-von-3': true,
    '/wohnmobil-bewerten/schritt-1-von-2': true,
    '/wohnmobil-bewerten/schritt-2-von-2': true,
    '/waardeer-mijn-camper': true,
    '/vurder-min-autocamper': true,
    '/valora-mi-autocaravana': true,
    '/ohodnotit-muj-motorhome': true,
    '/ocen-moj-kamper': true,
    '/vaerdera-min-husbil': true
  },
  hideFooter: {
    '/wohnmobil-bewerten': true,
    '/waardeer-mijn-camper': true,
    '/vurder-min-autocamper': true,
    '/valora-mi-autocaravana': true,
    '/ohodnotit-muj-motorhome': true,
    '/ocen-moj-kamper': true,
    '/vaerdera-min-husbil': true
  }

})
